import { trpc } from '../lib/trpc';
import { useAsync } from '../lib/useAsync';
import { mesLabel } from '../lib/format';

/**
 * Card READ-ONLY do INCC para a incorporadora: "qual índice reajusta meus
 * contratos este mês?". Consome `trpc.incc.vigente` (protectedProcedure) — a
 * série é nacional/global, sem dado de tenant. Autocontido: faz a própria query
 * e não interfere na página que o hospeda. Silencioso enquanto carrega/erra
 * (não polui a tela se a série ainda não existir).
 */

function fmtPct(n: number): string {
  return `${n > 0 ? '+' : ''}${n.toFixed(2).replace('.', ',')}%`;
}

export function CardInccVigente() {
  const { data } = useAsync(() => trpc.incc.vigente.query());
  if (!data) return null;

  const { ultimoMes, anoMesReferencia, percentualAcumulado, completa } = data;

  return (
    <div className="card p-4" data-testid="incc-vigente">
      <div className="flex items-center gap-1.5 text-xs text-ink-3">Índice de reajuste vigente</div>
      {completa && percentualAcumulado !== null ? (
        <>
          <div className="num mt-1 text-2xl font-semibold text-ink" data-testid="incc-vigente-valor">
            {fmtPct(percentualAcumulado)}
          </div>
          <div className="mt-0.5 text-xs text-ink-4">
            INCC acumulado (12 meses) que reajusta contratos com aniversário em {mesLabel(anoMesReferencia)}.
          </div>
        </>
      ) : (
        <>
          <div className="mt-1 text-[15px] font-medium text-ink">Aguardando publicação</div>
          <div className="mt-0.5 text-xs text-ink-4">
            Ainda faltam meses do INCC para fechar a janela de 12 meses. Os reajustes que dependem deles
            ficam retidos até a série completar; nada é estimado.
          </div>
        </>
      )}
      {ultimoMes && (
        <div className="mt-2 border-t border-line pt-2 text-xs text-ink-3">
          Último mês publicado: {mesLabel(ultimoMes.anoMes)} ({fmtPct(ultimoMes.variacaoPercentual)}).
        </div>
      )}
    </div>
  );
}
